export default "__VITE_ASSET__DWq8Dwhg__"